<script setup lang="ts">
/** Lightbox: the whole reference photo with the fitted elevation drawn over it (in perspective when the fit gave the front face's quad). */
import { computed } from 'vue';
import Icon from './Icon.vue';
import AppDialog from './AppDialog.vue';
import { ui } from '@/app/state';
import { fitOverlay } from '@/app/overlay';

const img = computed(() => ui.ref.images[0] ?? null);
const ov = computed(() => fitOverlay.value);
function close() { ui.lightbox = null; }
</script>

<template>
  <AppDialog :open="!!ui.lightbox" labelledby="lightboxTitle" cls="dlg--wide" @close="close">
    <div class="dlg-head">
      <h2 id="lightboxTitle" class="h-display">{{ ov ? 'Photo 1 with the fitted elevation' : 'Your photo' }}</h2>
      <button type="button" class="icon-btn" data-close aria-label="Close" @click="close"><Icon name="close" /></button>
    </div>
    <div v-if="img" class="zoom-scroll">
      <div class="zoom-img" :style="img.width && img.height ? { '--ar': (img.width / img.height).toFixed(4) } : undefined">
        <img :src="img.src" :alt="img.alt">
        <svg v-if="ov" viewBox="0 0 1 1" preserveAspectRatio="none" aria-hidden="true">
          <polygon class="ref-outline" :points="ov.quad.map((p) => `${p.x},${p.y}`).join(' ')" vector-effect="non-scaling-stroke" />
          <polygon v-for="r in ov.rects" :key="`h-${r.id}`" class="ref-halo" :points="r.points" vector-effect="non-scaling-stroke" />
          <polygon v-for="r in ov.rects" :key="r.id" class="ref-board" :data-board="r.id" :points="r.points" vector-effect="non-scaling-stroke" />
          <line v-for="l in ov.lines" :key="l.partId" class="ref-line" :x1="ov.carcass.left - 0.02" :x2="ov.carcass.right + 0.02" :y1="l.y" :y2="l.y" vector-effect="non-scaling-stroke" />
        </svg>
      </div>
    </div>
    <p v-if="ov" class="dlg-foot muted">The outlines are your design's boards, drawn to scale on the piece's front {{ ov.perspective ? 'in the photo’s perspective' : 'straight-on (the photo’s angle was not measured)' }}. Where they drift from the photo, change the value in Check or Shape.</p>
  </AppDialog>
</template>
